import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// The wallboard's named type scale. Without this, tailwind-merge files `text-caption` as a text
// colour and a later `text-red` silently drops it (or the reverse), so a badge loses its size.
const twMerge = extendTailwindMerge({
  extend: { theme: { text: ['caption', 'body', 'figure', 'display'] } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
